import { useIntl } from 'react-intl';

import { IOrderButtonProps, IOrderButtonTextArgs } from './types';

export const useOrderButtonProps = ({
  defaultClickEventHandler,
  enableOrdering,
}: IOrderButtonTextArgs): IOrderButtonProps => {
  const { formatMessage } = useIntl();
  return {
    onOrderClick: defaultClickEventHandler,
    orderButtonText: formatMessage({ id: enableOrdering ? 'order' : 'select' }),
  };
};
